import { GridItem } from '@tvg/fuse/grid';
import classNames from 'classnames';
import React from 'react';
import styles from './BannerContainer.module.css';

export interface BannerContainerProps {
  itemKey: number;
}

function BannerContainer({ itemKey }: BannerContainerProps) {
  return (
    <GridItem
      data-testid="gallery-banner-container"
      id={`recs-banner${itemKey}`}
      className={classNames(
        styles.bannerContainer,
        'grid-item grid-item--recs-banner grid-item--content-banner grid-item--hidden',
      )}
      data-content-in-grid-banner
    />
  );
}

export default React.memo(BannerContainer);
